export default {
  title: 'Performanță săptămânală',
  messages_sent: 'Mesaje trimise',
  messages_delivered: 'Mesaje livrate',
  click_rate: 'Rată medie de accesare',
  awaiting: 'În așteptarea confirmării',
  legend: {
    sent: 'Trimis',
    clicked: 'Accesat',
    delivered: 'Livrat',
  },
  error_messages: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
